import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConferenciaVolume, RequestAcompanhamentoRemessaProdutoRisco, ResponseAcompanhamentoRemessaProdutoRisco } from 'src/app/@shared/models/confVolume';
import { ConferenciaVolumeService } from 'src/app/services/confVolume/conferencia-volume.service';

@Component({
  selector: 'app-modal-transformar-produto-em-risco',
  templateUrl: './modal-transformar-produto-em-risco.component.html',
  styleUrls: ['./modal-transformar-produto-em-risco.component.scss']
})
export class ModalTransformarProdutoEmRiscoComponent implements OnInit {
  isLoading = false;
  loteID: number;
  operacao: any;
  public produtos = [];
  public displayedColumns = ['nrt', 'produtoOriginal', 'produtoRisco'];
  public paging = { index: 0, size: 5, length: 0 };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private conferenciaVolumeService: ConferenciaVolumeService,
    private ref: MatDialogRef<ModalTransformarProdutoEmRiscoComponent>,
  ) {
    this.loteID = data.loteID;
  }

  ngOnInit() {
    this.listarProdutos();
  }

  listarProdutos() {
    this.isLoading = true;

    const obj: RequestAcompanhamentoRemessaProdutoRisco = {
      loteID: this.loteID,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    }

    this.conferenciaVolumeService.acompanhamentoRemessaProdutoRisco(obj)
      .subscribe((response: ResponseAcompanhamentoRemessaProdutoRisco[]) => {
        this.produtos = response;
        this.paging.length = response.length > 0 ? (response[0].totalCount || 0) : 0;
        this.isLoading = false;
      })
  }

  confirmar() {
    this.conferenciaVolumeService.transformarProdutoEmRisco(this.loteID)
      .subscribe(
        (response) => {
          if (response.success) {
            return this.ref.close('success')
          } else {
            return this.openSnackBar(
              response.mensagem,
              'OK',
              5000,
              'danger-snackbar'
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
        })
  }

  pageChanged({ pageIndex, pageSize }) {
    this.paging = Object.assign(this.paging, {
      index: pageIndex,
      size: pageSize
    });
    this.listarProdutos();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
